define('plugin/client-login/step/ClientLoginStep',['require','lib/controller/booking/BaseStep','plugin/client-login/view/ClientLoginStepView','plugin/client-login/model/ClientSignInModel'],function (require) {

    var BaseStep = require('lib/controller/booking/BaseStep');
    var ClientLoginStepView = require('plugin/client-login/view/ClientLoginStepView');
    var ClientSignInModel = require('plugin/client-login/model/ClientSignInModel');

    return BaseStep.extend({

        _step: 'client_login',
        _clientModel: null,
        _signInModel: null,
        _handler: null,

        /**
         * Initialize models and subscribe to events
         */
        initialize: function () {
            BaseStep.prototype.initialize.apply(this);

            this._clientModel = this.getOption('clientModel');
            this._signInModel = this.getOption('signInModel');
            this._handler = this.getOption('handler');

            this.setIsSkipped(true);
        },

        /**
         * Returns step view
         *
         * @return ClientLoginStepView
         */
        getView: function () {
            var view = new ClientLoginStepView({
                clientModel: this._clientModel,
                signInModel: this._signInModel,
                termsModel: this._handler.getTermsController().getModel()
            });

            this.listenTo(view, 'signIn', _.bind(function (data) {
                this._handler.performSignIn(data.view.getDataToSignIn());
            }, this));

            this.listenTo(view, 'signUp', _.bind(function (data) {
                this._handler.performSignUp(data.view.getDataToSignUp());
            }, this));

            this.listenTo(view, 'dom:refresh', _.bind(function () {
                view.showTermsAndConditions(this._handler.getTermsController().getView());
            }, this));

            this.listenTo(view, 'clientLogged', this.done);
            this.listenTo(view, 'clientLoggedOut', this.done);

            return view;
        },

        /**
         * Returns true if user has been logged in
         *
         * @return Boolean
         */
        isValid: function () {
            if (this._clientModel.get('is_logged_in') && this._clientModel.get('id')) {
                return true;
            }
            return false;
        },
        
        getClientModel: function () {
            return this._clientModel;
        }

    });

});
